
//Digital Twin Configs

/**
 * Element types for digital twin
 */
export const elementTypes = {
    node: "node",
    edge: "edge",
};

//Metrics Configs

import { Colors } from "../../../../../../../styles/Theme/Colors";
import Theme from "../../../../../../../styles/Theme/Theme";

export const comfortMetricSubtypes = {
    Occupation: "Occupation",
    Luminosity: "Light Intensity",
    Temperature: "Temperature",
    Humidity: "Humidity",
    AirQuality: "CO2",
    SoundLevel: "Sound Level",
};

export const energyMetricsSubtypes = {
    ActiveEnergy: "Active Energy",
    ReactiveInductiveEnergy: "Reactive Inductive Energy",
    ReactiveCapacitiveEnergy: "Reactive Capacitive Energy",
    ActivePower: "Active Power",
    ReactiveInductivePower: "Reactive Inductive Power",
    ReactiveCapacitivePower: "Reactive Capacitive Power",
    ProductionPower: "Production Power",
}

export const periodicity = {
    DAILY: { periodicityType: "DAILY", daysToDisable: 31 },
    RAW: { periodicityType: "RAW", hoursToDisable: 12 },
    HOURLY: { periodicityType: "HOURLY", daysToDisable: 2 },
    MONTHLY: { periodicityType: "MONTHLY", daysToDisable: 730 },
    YEARLY: { periodicityType: "YEARLY" },
};

/**
 * Get the date format based on the selected periodicity
 * @param {*} selectedPeriodicity Periodicity selected
 * @param {*} language Language selected
 * @returns The date format
 */
export const getFormatDateByPeriodicity = (selectedPeriodicity, language) => {
    switch (selectedPeriodicity) {
        case periodicity.MONTHLY.periodicityType:
            return language === 'pt' ? 'MM/YYYY' : 'YYYY/MM';
        case periodicity.YEARLY.periodicityType:
            return 'YYYY';
        default:
            return language === 'pt' ? 'DD/MM/YYYY' : 'YYYY/MM/DD';
    }
}

/**
 * Get the metric subtype color for the chart
 * @param {*} metricSubtype Metric subtype
 * @returns The color
 */
export const getColorByChartMetricSubtype = (metricSubtype) => {
    switch (metricSubtype) {
        case comfortMetricSubtypes.Occupation:
            return Theme.color.occupation;
        case comfortMetricSubtypes.Luminosity:
            return Theme.color.ligthning;
        case comfortMetricSubtypes.Temperature:
            return Theme.color["temperature-estimated"];
        case comfortMetricSubtypes.Humidity:
            return Theme.color.humidity;
        case comfortMetricSubtypes.AirQuality:
            return Theme.color.co2;
        case comfortMetricSubtypes.SoundLevel:
            return Theme.color["sound-level"];
        default:
            return Colors["chart-light-13"]
    }
}

/**
 * Makes the text received with underscores and lowercase into a text with spaces and first letter uppercase
 * For example: if receive "ACTIVE_ENERGY" return "Active Energy"
 * @param {*} textForTranslation The text for translation
 * @returns The text for translation
 */
export const getTextForTranslation = (textForTranslation) => {
    return textForTranslation
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, char => char.toUpperCase());
}